<!--列表查看视图-->
<template>
  <el-dialog
    v-el-drag-dialog
    custom-class="business-info-dialog"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.AssociationBusinessInformationSI')"
    :close-on-click-modal="true"
    @close="innerVisible=false"
  >
    <div class="main-content">
      <div :class="'tabs-container' + (canOperateJob ? '' : ' cannot-operate-job')">
        <span class="lab-state">{{ labState }}</span>
        <el-tabs ref="tabs" v-model="activeTabName" type="card" @tab-click="handleTabClick">
          <el-tab-pane v-if="currentRow && !currentRow.masterFlag" :key="102" name="tabBasic" :label="$t('SeaExport.ImportOperation')">
            <basic-tab ref="tabBasic" :context="context" :action="action" />
          </el-tab-pane>
          <el-tab-pane v-if="currentRow && currentRow.masterFlag" :key="102" name="tabMasterBasic" :label="$t('SeaExport.ImportOperation')">
            <master-basic-tab ref="tabMasterBasic" :context="context" :action="action" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import basicTab from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/basicTab'
import masterBasicTab from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/masterBasicTab'
export default {
  name: 'RelatedSiFromWindow',
  components: {
    basicTab,
    masterBasicTab
  },
  props: {
    context: { type: Object, required: true },
    visible: { type: Boolean, required: true },
    relatedJob: { type: Object, required: false, default: null },
    canOperateJob: { type: Boolean, default: true }
  },
  data() {
    return {
      loading: false,
      showButton: false,
      innerVisible: false,
      action: 'look',
      currentRow: {},
      activeTabName: 'tabBasic',
      labState: ''
    }
  },
  watch: {
    async visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      try {
        const loading = getLoading()
        this.context.loading = true
        this.innerVisible = true
        await this.showDetail(this.relatedJob)
        loading.close()
        this.context.loading = false
      } catch (err) {
        throw err
      } finally {
        this.context.loading = false
      }
    }
  },
  methods: {
    async showDetail(relatedJob) {
      this.currentRow = relatedJob
      this.currentRow.path = ''
      this.labState = this.$t('SeaExport.BusinessStatus') + '：' + ColumnUtils.getJobStateCN(this.currentRow.jobState)
      this.activeTabName = this.currentRow.masterFlag ? 'tabMasterBasic' : 'tabBasic'
      this.handleTabClick()
    },
    handleTabClick() {
      this.$nextTick(() => {
        this.$refs[this.activeTabName].onShow(this.currentRow, true)
      })
    }
  }
}
</script>

<style lang="scss">
.el-dialog.business-info-dialog {
  display: flex;
  height: 600px;
  width: 1415px;
  flex-direction: column;
  .el-dialog {
    &__body {
      position: relative;
      display: flex;
      overflow: hidden;
    }
  }
  &.isfullScreen {
    overflow: hidden;
  }
  .el-tabs {
    display: flex;
    flex-direction: column;
    width: 100%;
    &__content {
      overflow: scroll;
    }
  }
  .lab-state {
    position: absolute;
    z-index: 999;
    right: 30%;
  }
  .tabs-container.cannot-operate-job {
    .el-button {
      &.el-button--primary:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #8fbaea;
        border-color: #8fbaea;
      }
      &.el-button--success:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #a1dcc1;
        border-color: #a1dcc1;
      }
      &.el-button--danger:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #fab6b6;
        border-color: #fab6b6;
      }
    }
    .sop-img {
      pointer-events: none;
    }
  }
}
</style>
